// extracted by mini-css-extract-plugin
module.exports = {"subjectTestListWrapper":"styles_subjectTestListWrapper__3b7Pc"};